import gql from 'graphql-tag';

export const AnswerChallenge = gql`
    mutation AnswerChallenge(
        $deviceId: DeviceId!
        $loginId: LoginId!
        $expiresAt: Long!
        $userContextId: String!
        $hmac: String!
        $twoFactorCode: Int
    ) {
        me {
            answerChallenge(
                deviceId: $deviceId
                loginId: $loginId
                expiresAt: $expiresAt
                userContextId: $userContextId
                hmac: $hmac
                twoFactorCode: $twoFactorCode
            ) {
                __typename
                ... on AuthenticationSucceeded {
                    accessToken
                    deviceId
                }
                ... on AuthenticationFailed {
                    errorDetails
                    errorTitle
                }
            }
        }
    }
`;
